import '@banno/jha-wc/src/forms/jha-form-currency-input/jha-form-currency-input';
import JhaFormCurrencyInput from '@banno/jha-wc/src/forms/jha-form-currency-input/JhaFormCurrencyInput';
import { html, PropertyValues } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { createRef, ref } from 'lit/directives/ref.js';
import { TmFormControl } from '../forms';

type JhaWcInputChanged = CustomEvent<string>;

const tagName = 'tm-currency-input';

@customElement(tagName)
export class TmCurrencyInput extends TmFormControl<number> {
    @property({ type: Number })
    public max?: number;

    @property({ type: Number })
    public min?: number;

    @property({ type: String })
    public placeholder?: string;

    @property({ type: String })
    public label?: string;

    @property({ type: Boolean })
    public left?: boolean;

    @property({ type: Boolean })
    public noDecimal?: boolean;

    @property()
    public firstChange = true;

    @property({ type: Boolean })
    public useCommas = false;

    private readonly currencyInputRef = createRef<JhaFormCurrencyInput>();

    public get currencyInput() {
        return this.currencyInputRef.value;
    }

    public validate() {
        if (!this.currencyInput) {
            return true;
        }

        return this.currencyInput.checkValidity();
    }

    protected updated(_changedProperties: PropertyValues): void {
        if (_changedProperties.has('initial')) {
            if (this.currencyInput && this.initial) {
                this.currencyInput.value = this.initial.toString();
            }
        }
    }

    protected render() {
        return html`
            <jha-form-currency-input
                ${ref(this.currencyInputRef)}
                @change=${(e: JhaWcInputChanged) => {
                    // The first change event is fired when the input is initialized with the initial value so we guard against calling changeValue() in that case
                    if (this.firstChange) {
                        this.firstChange = false;
                        return;
                    }
                    this.changeValue(parseFloat(e.detail));
                }}
                .label=${this.label ?? ''}
                .max=${this.max ?? Number.NaN}
                .min=${this.min ?? Number.NaN}
                .placeholder=${this.placeholder ?? ''}
                .value=${this.initial?.toString() ?? ''}
                .useCommas=${this.useCommas}
                allowedCharacters="[0-9.,-]+"
                left=${ifDefined(this.left)}
                .noDecimal=${this.noDecimal}
            ></jha-form-currency-input>
        `;
    }
}

declare global {
    interface HTMLElementTagNameMap {
        [tagName]: TmCurrencyInput;
    }
}
